module.exports = __webpack_public_path__ + "img/quit_fullscreen_white_ico.730fc302.svg";